export const patriotic = [
  {
    number: 'P100',
    hasModel: false
  },
  {
    number: 'P101',
    hasModel: false
  },
  {
    number: 'P102',
    hasModel: false
  },
  {
    number: 'P103',
    hasModel: false
  },
  {
    number: 'P104',
    hasModel: false
  },
  {
    number: 'P105',
    hasModel: false
  },
  {
    number: 'P106',
    hasModel: false
  },
  {
    number: 'P107',
    hasModel: false
  },
  {
    number: 'P108',
    hasModel: false
  },
  {
    number: 'P109',
    hasModel: false
  },
  {
    number: 'P110',
    hasModel: false
  },

]